import React, { Fragment } from "react";
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import { HeaderThree, ContactTwo, FooterTwo } from "../containers";

const Contact = () => (
  <Fragment>
    <Seo
      title="Contact Tech Ayukta — IT Services, Web & App Development, ERP & SAP Solutions"
      description="Reach out to Tech Ayukta for professional IT Consulting, Web Development, Mobile App Development, ERP Solutions, SAP Services, Digital Transformation, and Custom Software Development. Our team is here to assist you with any project or inquiry."
      keywords="
    Tech Ayukta Contact,
    Contact Tech Ayukta,
    IT Consulting Support,
    Web Development Company Contact,
    Mobile App Development Contact,
    ERP Solutions Contact,
    SAP Services Contact,
    Software Development Company,
    Business Automation Solutions,
    Digital Transformation Services,
    IT Support India,
    Tech Ayukta Customer Support
  "
      canonical="https://www.techayukta.com/contact"
    />

    <HeaderThree />
    <Breadcrumb
      pageName="Contact Us"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
    <ContactTwo className="space-top space-extra-bottom" />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default Contact;
